import {
    SYSTEM_SUBMIT_SALARYTYPE_BEGIN,
    SYSTEM_SUBMIT_SALARYTYPE_SUCCESS,
    SYSTEM_SUBMIT_SALARYTYPE_FAILURE,
    SYSTEM_SUBMIT_SALARYTYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitSalaryType(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_SALARYTYPE_BEGIN,
      });
  
      let apiurl = '/api/b/salaryType/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/salaryType/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_SALARYTYPE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_SALARYTYPE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitSalaryTypeError() {
    return {
      type: SYSTEM_SUBMIT_SALARYTYPE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_SALARYTYPE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitSalaryTypePending: true,
          submitSalaryTypeError: null,
        };
  
      case SYSTEM_SUBMIT_SALARYTYPE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitSalaryTypePending: false,
          submitSalaryTypeError: null,
        };
  
      case SYSTEM_SUBMIT_SALARYTYPE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitSalaryTypePending: false,
          submitSalaryTypeError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_SALARYTYPE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitSalaryTypeError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitSalaryType.js